import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useChat } from '@/shared/hooks/useChat';
import MessageList from './MessageList';
import ChatInput from './ChatInput';
import MessageSkeleton from './MessageSkeleton';

export default function ChatWindow() {
  const { threadId: urlThreadId } = useParams();
  const {
    messages,
    isStreaming,
    isLoadingHistory,
    threadId,
    sendMessage,
    submitForm,
    stopStreaming,
    resetChat,
    loadMessages,
  } = useChat();

  useEffect(() => {
    if (urlThreadId && urlThreadId !== threadId) {
      loadMessages(urlThreadId);
    } else if (!urlThreadId && (messages.length > 0 || threadId)) {
      resetChat();
    }
  }, [urlThreadId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSend = useCallback(
    (text) => {
      if (text.trim()) {
        sendMessage(text);
      }
    },
    [sendMessage]
  );

  return (
    <div className="flex flex-1 flex-col min-h-0">
      {/* Messages */}
      <div className="flex-1 overflow-hidden">
        {isLoadingHistory ? (
          <MessageSkeleton count={4} />
        ) : (
          <MessageList
            messages={messages}
            isStreaming={isStreaming}
            onFormSubmit={submitForm}
            onSuggestionClick={handleSend}
          />
        )}
      </div>

      {/* Input */}
      <div className="border-t border-border p-4 pb-safe">
        <ChatInput
          onSend={handleSend}
          isStreaming={isStreaming}
          onStop={stopStreaming}
          disabled={isLoadingHistory}
        />
      </div>
    </div>
  );
}
